module.exports = "/dist/assets/images/search.svg";